/**
 * useBackgroundRefresh Hook
 * Manages background token refresh service
 */

import { useEffect, useCallback } from "react";

import { BackgroundRefreshService } from "../services/backgroundRefreshService";
import { useWithingsAuth } from "./useWithingsAuth";

/**
 * Hook for managing background token refresh
 *
 * @returns {object} Object with forceRefresh and isServiceRunning functions
 *
 */
export const useBackgroundRefresh = () => {
  const { isAuthenticated } = useWithingsAuth();

  // Start/stop background refresh based on authentication status
  useEffect(() => {
    if (isAuthenticated) {
      BackgroundRefreshService.start();
    } else {
      BackgroundRefreshService.stop();
    }

    return () => {
      BackgroundRefreshService.stop();
    };
  }, [isAuthenticated]);

  const forceRefresh = useCallback(async () => {
    if (isAuthenticated) {
      await BackgroundRefreshService.forceRefreshCheck();
    }
  }, [isAuthenticated]);

  const isServiceRunning = useCallback(() => {
    return BackgroundRefreshService.isServiceRunning();
  }, []);

  return {
    forceRefresh,
    isServiceRunning,
  };
};
